import { FunctionComponent } from "react";
import { Button } from "@chakra-ui/react";
import ImFucked from "../components/ImFucked";
import styles from "./Ver1CurrentCopy2.module.css";
const Ver1CurrentCopy2: FunctionComponent = () => {
  return (
    <div className={styles.ver1CurrentCopy2}>
      <ImFucked />
    </div>
  );
};

export default Ver1CurrentCopy2;
